<template>
  <div class="login-page">
    <!-- 状态栏装饰 - 顶部通栏 -->
    <div class="status-bar">
      <img src="/login-images/Layer_1.png" alt="status" class="status-img" />
    </div>
    
    <div class="content">
      <!-- 顶部装饰 -->
      <div class="top-decoration">
        <img src="/login-images/4ecd9bee-f1b3-41f2-a0e5-c01c6e998e3e.png" alt="XcoPack Recycling 星碳计划" class="logo-img" />
      </div>

      <!-- 标题区域 -->
      <div class="title-section">
        <h1 class="main-title">欢迎参加活动</h1>
        <p class="sub-title">登录后即可参与本次活动</p>
      </div>

      <!-- 登录表单卡片 -->
      <div class="login-card">
        <div class="form-row">
          <label class="form-label">手机号</label>
          <input 
            v-model="form.phone" 
            type="tel" 
            maxlength="11"
            placeholder="请输入手机号" 
            class="form-input"
          />
        </div>
        
        <div class="divider"></div>
        
        <div class="form-row">
          <label class="form-label">验证码</label>
          <input 
            v-model="form.code" 
            type="tel" 
            maxlength="6"
            placeholder="请输入验证码" 
            class="form-input verify-input"
            @input="limitCodeLength"
          />
          <button 
            class="verify-btn"
            :disabled="countdown > 0 || !form.phone"
            @click="sendCode"
          >
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>
        
        <!-- 登录按钮 -->
        <button 
          class="login-btn"
          :disabled="loading"
          @click="handleLogin"
        >
          <span v-if="loading">登录中...</span>
          <span v-else>点击登录</span>
        </button>
      </div>

      <!-- 底部区域 -->
      <div class="bottom-section">
        <!-- FIDO DIDO贴纸标签 -->
        <p class="sticker-label">FIDO DIDO限量版贴纸</p>

        <!-- 贴纸图片 -->
        <div class="sticker-images">
          <img src="/login-images/2e52bd305e689cb3953432485cf809b980aa03bd.png" alt="sticker1" class="sticker-img sticker-left" />
          <img src="/login-images/a916a6bde09ff528c4ce943adda978b1429eebf0.png" alt="sticker2" class="sticker-img sticker-right" />
        </div>

        <!-- 品牌好友区域 -->
        <div class="brand-section">
          <img src="/login-images/Group1.png" alt="Fido Dido" class="fido-dido-logo" />
        </div>

        <!-- 合作品牌 -->
        <div class="partner-brands">
          <img src="/login-images/ef26d576-1977-4a2f-ad4d-848fea0b2b58.png" alt="品牌好友" class="partner-logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showSuccessToast, showFailToast } from '@/utils/request'
import { sendSms } from '@/api/sms'
import { loginByPhone } from '@/api/user'

export default {
  name: 'LoginPage',
  setup() {
    const route = useRoute()
    const router = useRouter()
    
    const form = ref({
      phone: '',
      code: ''
    })
    const countdown = ref(0)
    const loading = ref(false)
    let timer = null

    onMounted(() => {
      // 检查是否已登录
      const storedPhone = localStorage.getItem('userPhone')
      if (storedPhone) {
        // 已登录，检查是否已完成核销
        const checkinStatus = localStorage.getItem('checkinStatus')
        if (checkinStatus === '1') {
          // 已核销，跳转到核销码页面
          router.push('/checkin')
        } else {
          // 未核销，跳转到活动页面
          router.push('/activity')
        }
        return
      }
      
      // 保存邀请人信息
      const urlInviter = route.query.inviter
      if (urlInviter) {
        localStorage.setItem('inviter', urlInviter)
      }
    })

    // 限制验证码长度
    const limitCodeLength = () => {
      // 过滤非数字字符并限制长度为6
      let value = form.value.code || ''
      value = value.replace(/\D/g, '')
      if (value.length > 6) {
        value = value.slice(0, 6)
      }
      form.value.code = value
    }

    // 发送验证码
    const sendCode = async () => {
      if (!form.value.phone || !/^1[3-9]\d{9}$/.test(form.value.phone)) {
        showFailToast('请输入正确的手机号')
        return
      }

      try {
        const res = await sendSms({ phone: form.value.phone })
        if (res.code === 200) {
          showSuccessToast('验证码已发送，请查收短信')
          countdown.value = 60
          timer = setInterval(() => {
            countdown.value--
            if (countdown.value <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          showFailToast(res.message || '验证码发送失败，请重试')
        }
      } catch (error) {
        console.error(error)
        showFailToast('验证码发送失败，请重试')
      }
    }

    // 登录
    const handleLogin = async () => {
      if (!form.value.phone || !/^1[3-9]\d{9}$/.test(form.value.phone)) {
        showFailToast('请输入正确的手机号')
        return
      }
      if (!form.value.code) {
        showFailToast('请输入验证码')
        return
      }

      loading.value = true
      try {
        const inviter = localStorage.getItem('inviter') || ''
        const res = await loginByPhone({
          phone: form.value.phone,
          code: form.value.code,
          inviter: inviter
        })
        
        if (res.code === 200) {
          showSuccessToast('登录成功')
          localStorage.setItem('userPhone', form.value.phone)
          // 保存用户状态
          const user = res.data
          if (user && user.checkinStatus !== undefined) {
            localStorage.setItem('checkinStatus', String(user.checkinStatus))
          }
          if (user && user.followedAccount1 !== undefined) {
            localStorage.setItem('followedAccount1', String(user.followedAccount1))
          }
          if (user && user.followedAccount2 !== undefined) {
            localStorage.setItem('followedAccount2', String(user.followedAccount2))
          }
          // 根据状态决定跳转页面
          if (user && user.checkinStatus === 1) {
            // 已核销，跳转到核销码页面
            router.push('/checkin')
          } else if (user && user.followedAccount1 === 1 && user.followedAccount2 === 1) {
            // 已完成关注任务但未核销，跳转到核销码页面
            router.push('/checkin')
          } else {
            // 未完成关注任务，跳转到活动页面
            router.push('/activity')
          }
        } else {
          showFailToast(res.message || '登录失败')
        }
      } catch (error) {
        console.error(error)
        showFailToast('登录失败')
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      countdown,
      loading,
      sendCode,
      handleLogin,
      limitCodeLength
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.login-page {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  width: 100%;
  max-width: 375px;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 15px 0;
}

/* 顶部装饰 */
.top-decoration {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  margin-bottom: 5px;
  flex-shrink: 0;
}

.logo-img {
  width: 75px;
  height: auto;
  object-fit: contain;
}

/* 状态栏 - 顶部通栏，左右顶边 */
.status-bar {
  width: 100%;
  height: 14px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

.status-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 标题区域 */
.title-section {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 15px;
  flex-shrink: 0;
}

.main-title {
  font-size: 28px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 32px;
  margin-bottom: 8px;
}

.sub-title {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #000000;
  line-height: 18px;
}

/* 登录卡片 */
.login-card {
  width: 100%;
  max-width: 340px;
  margin: 0 auto 20px;
  background-color: #2c2a29;
  border-radius: 8px;
  padding: 12px 20px 15px;
  position: relative;
}

.form-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  position: relative;
}

.form-label {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 24px;
  width: 60px;
  flex-shrink: 0;
}

.form-input {
  background: transparent;
  border: none;
  outline: none;
  font-size: 13px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #ffffff;
  line-height: 24px;
  flex: 1;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.verify-input {
  flex: 1;
}

.verify-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  min-width: 80px;
  height: 28px;
  padding: 0 6px;
  background-color: #de4c36;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
}

.verify-btn:disabled {
  background-color: #999;
  cursor: not-allowed;
}

.divider {
  width: calc(100% + 40px);
  height: 1px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
  margin: 0 -20px;
}

/* 登录按钮 */
.login-btn {
  display: block;
  width: 100%;
  height: 40px;
  margin: 15px auto 0;
  background-color: #1580b9;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.login-btn:disabled {
  background-color: #999;
  cursor: not-allowed;
}

/* 底部区域容器 */
.bottom-section {
  margin-top: auto;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 贴纸标签 */
.sticker-label {
  font-size: 11px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #000000;
  line-height: 16px;
  text-align: center;
  margin-bottom: 8px;
}

/* 贴纸图片 */
.sticker-images {
  position: relative;
  width: 240px;
  height: 100px;
  margin: 0 auto 10px;
}

.sticker-img {
  position: absolute;
  width: 120px;
  height: 80px;
  object-fit: contain;
}

.sticker-left {
  left: 15px;
  top: 10px;
  transform: rotate(-10deg);
  z-index: 1;
}

.sticker-right {
  right: 15px;
  top: 10px;
  transform: rotate(10deg);
  z-index: 2;
}

/* 品牌好友区域 */
.brand-section {
  text-align: center;
  margin-top: 5px;
}

.fido-dido-logo {
  width: 120px;
  height: auto;
  object-fit: contain;
}

/* 合作品牌 */
.partner-brands {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}

.partner-logo {
  width: 180px;
  height: auto;
  object-fit: contain;
}

/* 大屏幕适配 - 减少空白 */
@media screen and (min-height: 800px) {
  .content {
    justify-content: flex-start;
    padding-top: 10px;
  }
  
  .top-decoration {
    padding-top: 25px;
  }
  
  .title-section {
    margin-top: 20px;
    margin-bottom: 25px;
  }
  
  .login-card {
    margin-bottom: 30px;
  }
  
  .bottom-section {
    margin-top: 0;
  }
}

/* 响应式适配 - 小屏幕 */
@media screen and (max-height: 700px) {
  .top-decoration {
    padding-top: 15px;
  }
  
  .logo-img {
    width: 60px;
  }
  
  .main-title {
    font-size: 22px;
    line-height: 26px;
  }
  
  .sub-title {
    font-size: 11px;
  }
  
  .login-card {
    padding: 10px 15px 12px;
    margin-bottom: 15px;
  }
  
  .form-row {
    padding: 6px 0;
  }
  
  .form-label {
    font-size: 12px;
    line-height: 20px;
    width: 50px;
  }
  
  .form-input {
    font-size: 11px;
    line-height: 20px;
  }
  
  .verify-btn {
    width: 70px;
    height: 22px;
    font-size: 9px;
    line-height: 22px;
  }
  
  .login-btn {
    height: 34px;
    font-size: 13px;
    line-height: 34px;
    margin-top: 12px;
  }
  
  .sticker-images {
    width: 200px;
    height: 85px;
  }
  
  .sticker-img {
    width: 100px;
    height: 70px;
  }
  
  .fido-dido-logo {
    width: 100px;
  }
  
  .partner-logo {
    width: 140px;
  }
}

/* 超小屏幕 */
@media screen and (max-height: 600px) {
  .top-decoration {
    padding-top: 10px;
  }
  
  .title-section {
    margin-top: 10px;
    margin-bottom: 12px;
  }
  
  .sticker-images {
    width: 180px;
    height: 75px;
  }
  
  .sticker-img {
    width: 90px;
    height: 60px;
  }
}
</style>